import { defineStore } from 'pinia';
import type { ResponseModel } from '~/interfaces/api';
import { maxAge } from '@/common/const';
import { API } from '@/api/api';
import { useGlobalStore } from '~/stores/global';

export const cookieKey = 'history';
// cookie.value = 4890705%2C6354619%2C5492476%2C4781088%2C5123115%2C4869248
export const useHistoryStore = defineStore('History', () => {
  const ids = ref<string[] | number[]>([]);
  const histories = ref<ResponseModel[]>([]);
  const cookie = useCookie(cookieKey, {
    path: '/',
    maxAge,
  });

  async function getHistoryEnvironment() {
    ids.value = cookie.value ? cookie.value.toString().trim().split(',') : [];
    if (ids.value.length > 0) {
      const globalStore = useGlobalStore();
      await API.get('/models', {
        params: {
          ids: ids.value.slice(0, 6).toString(),
          region_id: globalStore.region.id || 1,
          sem: globalStore.sem,
          device: globalStore.device || 1,
        },
      })
        .then((models) => {
          histories.value = models.data;
        })
        .catch(() => {});
    }
  }

  function addHistory(model: ResponseModel) {
    ids.value = cookie.value
      ? cookie.value
          .toString()
          .split(',')
          .reduce((uniq: number[], currentValue: string) => {
            !uniq.includes(Number(currentValue)) &&
              uniq.push(Number(currentValue));
            return uniq;
          }, [])
      : [];
    if (model?.id && !ids.value.includes(model.id)) {
      cookie.value = [model.id, ...ids.value].slice(0, 6).toString();
    }
  }

  return {
    histories,
    getHistoryEnvironment,
    addHistory,
    ids,
  };
});
